import { render, staticRenderFns } from "./StepTwoIllustration.vue?vue&type=template&id=873ea9fa&"
import script from "./StepTwoIllustration.vue?vue&type=script&lang=js&"
export * from "./StepTwoIllustration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports